import React, {useState, useEffect} from 'react';
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { isLoggedIn, isVerifyEmail, logout} from "../../../features/user";
//import { setLoading} from "../../features/common";
import { useTranslation } from 'react-i18next';
import {checkValidToken, userLoggedIn} from "../../../Helper"

import Frame from '../../widgets/Frame';
import Background from '../../widgets/Background';
import ListCard from '../../widgets/ListCard';

export function PrintList() {
    const [state, setState] = useState({ search: "" });
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const isUserLoggedIn = useSelector(isLoggedIn);
    const isUserVerifyEmail = useSelector(isVerifyEmail);

    useEffect(()=>{
        checkValidToken(navigate, dispatch, false, true, "/start");
        userLoggedIn(isUserLoggedIn, isUserVerifyEmail, navigate, dispatch);
       // eslint-disable-next-line
    },[]);


    const handleChange = (e) => {
        setState({
            ...state,
            [e.target.id]: e.target.value,
        });
    };

    return (
        <Frame headerWhite={true} showMenu={true} showNav={true}>
            <div className='main print-list'>
                <div className='main-body'>
                    <div className='left-main'></div>
                    <div className='right-main mt70'>
                    <Background >
                        <div className='right-main-inner'>
                            {/* <ListCard title={"books_production"} items={[{name:"digital_books_production"}, {name:"audiobooks_production"}, {name:"narration"}]}></ListCard>
                            <div className='mb40'></div> */}
                            <ListCard title={"printing_agencies"} items={[{name:"northen_area"}, {name:"central_area"}, {name:"southen_area"}]}></ListCard>
                            <div className='mb40'></div>
                        </div>
                    </Background>
                    </div>
                    <div className='left-main'>
                    </div>
                </div>
            </div>
        </Frame>
    );
}